/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
import { useState, useEffect } from "react";
import adminServices from "../../../../services/adminServices";

export default function ContractTab({ clientDetails }) {
  const clientId = clientDetails?.id;
  const isFullCreator = clientDetails?.featureToggleMode === "FULL_CREATOR";

  const EMPTY = {
    learnerSeats: "",
    creatorSeats: "",
    startDate: "",
    endDate: "",
    notes: "",
  };

  const [contract, setContract] = useState(null);
  const [formData, setFormData] = useState(EMPTY);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState("");

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "—";

  const formatCode = clientDetails?.dateFormat?.code || 'MM/DD/YYYY';
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = String(date.getFullYear());

  switch (formatCode.toUpperCase()) {
    case 'DD/MM/YYYY': return `${dd}/${mm}/${yyyy}`;
    case 'MM/DD/YYYY': return `${mm}/${dd}/${yyyy}`;
    case 'YYYY/MM/DD': return `${yyyy}/${mm}/${dd}`;
    case 'YYYY-MM-DD': return `${yyyy}-${mm}-${dd}`;
    case 'DD-MM-YYYY': return `${dd}-${mm}-${yyyy}`;
    case 'MM-DD-YYYY': return `${mm}-${dd}-${yyyy}`;
    case 'DD.MM.YYYY': return `${dd}.${mm}.${yyyy}`;
    default:           return `${mm}/${dd}/${yyyy}`;
  }
};

  const toInputDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "";
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${date.getFullYear()}-${mm}-${dd}`;
  };

  const loadContract = async () => {
    if (!clientId) return;
    setLoading(true);
    try {
      const res = await adminServices.getClientContract(clientId);
      if (res.ok && res.data && (res.data.learnerSeats || res.data.startDate || res.data.endDate || res.data.notes)) {
        setContract(res.data);
        setFormData({
          learnerSeats: res.data.learnerSeats ?? "",
          creatorSeats: res.data.creatorSeats ?? "",
          startDate: toInputDate(res.data.startDate),
          endDate: toInputDate(res.data.endDate),
          notes: res.data.notes || "",
        });
      } else {
        setContract(null);
        setFormData(EMPTY);
      }
    } catch {
      setContract(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadContract(); }, [clientId]);

  const validate = () => {
    const errs = {};
    if (formData.startDate && formData.endDate && formData.startDate > formData.endDate) {
      errs.endDate = "End date must be after start date.";
    }
    if (formData.learnerSeats !== "" && Number(formData.learnerSeats) < 0) {
      errs.learnerSeats = "Learner Seats cannot be negative.";
    }
    if (isFullCreator) {
      if (formData.creatorSeats !== "" && Number(formData.creatorSeats) < 0) {
        errs.creatorSeats = "Content Creator Seats cannot be negative.";
      }
      const seats = parseInt(formData.creatorSeats, 10);
      if (!isNaN(seats) && seats > 10) {
        errs.creatorSeats = "Content Creator Seats cannot exceed 10.";
      }
    }
    return errs;
  };

  const handleSave = async () => {
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setErrors({});
    setSaving(true);
    try {
      let creatorSeats = 0;
      if (isFullCreator && formData.creatorSeats !== "") {
        creatorSeats = Number(formData.creatorSeats);
      }
      const res = await adminServices.saveClientContract(clientId, {
        learnerSeats: formData.learnerSeats !== "" ? Number(formData.learnerSeats) : 0,
        creatorSeats,
        startDate: formData.startDate || null,
        endDate: formData.endDate || null,
        notes: formData.notes || null,
        featureToggleMode: clientDetails?.featureToggleMode,
         schemaName : clientDetails?.slug ? `tenant_${clientDetails.slug}` : 'public'
      });
      if (res.ok) {
        setToast("Contract saved successfully.");
        setIsEditing(false);
        loadContract();
      } else {
        setToast(res.data?.message || "Failed to save contract.");
      }
    } catch {
      setToast("Failed to save contract.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (contract) {
      setFormData({
        learnerSeats: contract.learnerSeats ?? "",
        creatorSeats: contract.creatorSeats ?? "",
        startDate: toInputDate(contract.startDate),
        endDate: toInputDate(contract.endDate),
        notes: contract.notes || "",
      });
    } else {
      setFormData(EMPTY);
    }
    setErrors({});
    setIsEditing(false);
  };

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-3xl">
      {/* Toast */}
      {toast && (
        <div className="mb-4 px-4 py-2 bg-gray-800 text-white text-sm rounded-lg flex items-center justify-between">
          {toast}
          <button onClick={() => setToast("")} className="ml-4 text-gray-300 hover:text-white text-xs">✕</button>
        </div>
      )}

      <div className="bg-white rounded-lg border border-gray-200 p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-semibold text-gray-800">Contract Terms</h2>
          {!isEditing && (
            <button
              onClick={() => setIsEditing(true)}
              className="flex items-center gap-1.5 text-xs text-blue-600 hover:text-blue-700 border border-blue-200 hover:border-blue-400 rounded px-3 py-1.5 transition-colors"
            >
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              {contract ? "Edit" : "Add Contract"}
            </button>
          )}
        </div>

        {isEditing ? (
          /* ── Edit mode ── */
          <div className="space-y-4">
            {/* Learner Seats + Creator Seats */}
            <div className={`grid gap-3 ${isFullCreator ? "grid-cols-2" : "grid-cols-1 max-w-xs"}`}>
              <div>
                <label htmlFor="learnerSeats" className="block text-xs text-gray-600 mb-1">
                  Learner Seats
                  <input
                    id="learnerSeats"
                    type="number"
                    min="0"
                    value={formData.learnerSeats}
                    onKeyDown={(e) => e.key === '-' && e.preventDefault()}
                    onChange={(e) => {
                      setFormData({ ...formData, learnerSeats: e.target.value });
                      setErrors({ ...errors, learnerSeats: undefined });
                    }}
                    className={`w-full border rounded px-3 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1 ${errors.learnerSeats ? "border-red-400" : "border-gray-300"}`}
                  />
                </label>
                {errors.learnerSeats && (
                  <p className="text-[10px] text-red-500 mt-0.5">{errors.learnerSeats}</p>
                )}
              </div>
              {isFullCreator && (
                <div>
                  <label htmlFor="creatorSeats" className="block text-xs text-gray-600 mb-1">
                    Content Creator Seats <span className="text-gray-400">(max 10)</span>
                    <input
                      id="creatorSeats"
                      type="number"
                      min="0"
                      max="10"
                      value={formData.creatorSeats}
                      onKeyDown={(e) => e.key === '-' && e.preventDefault()}
                      onChange={(e) => {
                        const val = Math.max(0, Number(e.target.value));
                        setFormData({ ...formData, creatorSeats: val });
                        setErrors({ ...errors, creatorSeats: undefined });
                      }}
                      className={`w-full border rounded px-3 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1 ${errors.creatorSeats ? "border-red-400" : "border-gray-300"}`}
                    />
                  </label>
                  {errors.creatorSeats && (
                    <p className="text-[10px] text-red-500 mt-0.5">{errors.creatorSeats}</p>
                  )}
                </div>
              )}
            </div>

            {/* Start Date / End Date */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label htmlFor="startDate" className="block text-xs text-gray-600 mb-1">
                  Start Date
                  <input
                    id="startDate"
                    type="date"
                    value={formData.startDate}
                    onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
                    className="w-full border border-gray-300 rounded px-3 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1"
                  />
                </label>
              </div>
              <div>
                <label htmlFor="endDate" className="block text-xs text-gray-600 mb-1">
                  End Date
                  <input
                    id="endDate"
                    type="date"
                    value={formData.endDate}
                    onChange={(e) => {
                      setFormData({ ...formData, endDate: e.target.value });
                      setErrors({ ...errors, endDate: undefined });
                    }}
                    className={`w-full border rounded px-3 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1 ${errors.endDate ? "border-red-400" : "border-gray-300"}`}
                  />
                </label>
                {errors.endDate && (
                  <p className="text-[10px] text-red-500 mt-0.5">{errors.endDate}</p>
                )}
              </div>
            </div>

            {/* Notes */}
            <div>
              <label htmlFor="notes" className="block text-xs text-gray-600 mb-1">
                Notes
                <textarea
                  id="notes"
                  value={formData.notes}
                  onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                  rows={3}
                  placeholder="Optional notes about this contract…"
                  className="w-full border border-gray-300 rounded px-3 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none mt-1"
                />
              </label>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={handleSave}
                disabled={saving}
                className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white text-xs font-medium px-4 py-1.5 rounded transition-colors flex items-center gap-1.5"
              >
                {saving && (
                  <svg className="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                )}
                {saving ? "Saving…" : "Save Contract"}
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="border border-gray-300 hover:border-gray-400 text-gray-600 text-xs font-medium px-4 py-1.5 rounded transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : null}

        {!isEditing && contract && (
          <div className="space-y-4">
            {/* Subscription Status */}
            {contract.subscriptionStatus && (
              <div className="p-3 rounded-lg border border-gray-100 bg-gray-50 flex items-center justify-between">
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">Subscription Status</p>
                  <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${
                    contract.subscriptionStatus === 'ACTIVE' ? 'bg-green-100 text-green-700' :
                    contract.subscriptionStatus === 'TRIAL' ? 'bg-amber-100 text-amber-700' :
                    contract.subscriptionStatus === 'RESTRICTED' ? 'bg-red-100 text-red-700' :
                    'bg-gray-100 text-gray-600'
                  }`}>
                    <span className={`w-1.5 h-1.5 rounded-full ${
                      contract.subscriptionStatus === 'ACTIVE' ? 'bg-green-500' :
                      contract.subscriptionStatus === 'TRIAL' ? 'bg-amber-500' :
                      'bg-red-500'
                    }`} />
                    {contract.subscriptionStatus}
                  </span>
                </div>
                {contract.trialEndDate && (
                  <div className="text-right">
                    <p className="text-xs text-gray-400 mb-0.5">Trial Ends</p>
                    <p className="text-xs font-medium text-amber-700">{formatDate(contract.trialEndDate)}</p>
                  </div>
                )}
              </div>
            )}

            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-gray-400 mb-0.5">Learner Seats</p>
                <p className="text-xs font-medium text-gray-800">{contract.learnerSeats ?? "—"}</p>
              </div>
              {isFullCreator && (
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">Content Creator Seats</p>
                  <p className="text-xs font-medium text-gray-800">{contract.creatorSeats ?? "—"}</p>
                </div>
              )}
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-gray-400 mb-0.5">Start Date</p>
                <p className="text-xs font-medium text-gray-800">{formatDate(contract.startDate)}</p>
              </div>
              <div>
                <p className="text-xs text-gray-400 mb-0.5">End Date</p>
                <p className="text-xs font-medium text-gray-800">{formatDate(contract.endDate)}</p>
              </div>
            </div>

          

            <div>
              <p className="text-xs text-gray-400 mb-0.5">Notes</p>
              <p className="text-xs text-gray-700 whitespace-pre-wrap">{contract.notes || "—"}</p>
            </div>
            {contract.updatedAt && (
              <p className="text-xs text-gray-400">Last updated {formatDate(contract.updatedAt)}</p>
            )}
          </div>
        )}

        {!isEditing && !contract && (
          <p className="text-xs text-gray-400 py-4 text-center">
            No contract terms added yet.{" "}
            <button onClick={() => setIsEditing(true)} className="text-blue-600 hover:underline">
              Add contract
            </button>
          </p>
        )}
      </div>
    </div>
  );
}
